export default "__VITE_ASSET__722a309f__"